function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 列表
 * @param pram
 * @constructor
 */
export function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = pram || {},
    fundType = _ref.fundType,
    page = _ref.page,
    limit = _ref.limit,
    _ref$dateRange = _ref.dateRange,
    dateRange = _ref$dateRange === void 0 ? [] : _ref$dateRange,
    supplierId = _ref.supplierId;
  var _dateRange = _slicedToArray(dateRange, 2),
    st = _dateRange[0],
    et = _dateRange[1];
  var data = {
    fundType: fundType,
    page: page,
    limit: limit,
    endDate: et,
    startDate: st,
    supplierId: supplierId
  };
  return request({
    url: '/admin/business/supplier/fund-detail/list',
    method: 'GET',
    params: data
  });
}
var handSubmit = function handSubmit() {
  var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var amount = datas.amount,
    fundType = datas.fundType,
    recordProofUrl = datas.recordProofUrl,
    relatedAccount = datas.relatedAccount,
    remark = datas.remark,
    supplierId = datas.supplierId;
  return {
    amount: amount,
    fundType: fundType,
    recordProofUrl: recordProofUrl,
    relatedAccount: relatedAccount,
    remark: remark,
    supplierId: supplierId
  };
};

/**
 * 更新
 * @param pram
 * @constructor
 */
export function submitSetting(pram) {
  return request({
    url: '/admin/business/supplier/fund-detail/save',
    method: 'post',
    data: _objectSpread({}, handSubmit(pram))
  });
}

/**
 * 详情
 * @param id
 * @constructor
 */
export function getComDetail(id) {
  return request({
    url: '/admin/business/supplier/fund-detail/info',
    method: 'GET',
    params: {
      id: id
    }
  });
}